/* eslint-disable no-unused-vars */

export const imgDomain = "https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/";
